import React from "react";

export default function UserView() {
  return (
    <div className="bg-white rounded h-screen p-4 text-center">
      Kullanıcı Detayları Çalışma Aşamasında Lütfen bekleyin...
    </div>
  );
}
